import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DataTerm from '../../../atoms/list/DataTerm';
import DataDefinition from '../../../atoms/list/DataDefinition';
import DefinitionList from '../../DefinitionList';
import { readableNumberParts } from '../../../../helpers/Numbers';
const InvonedDossierFinances = ({ dossier }) => {
    const items = [
        {
            label: 'Heffingsbedrag',
            value: dossier.specification.assigned_headsum,
        },
        {
            label: 'Invorderingskosten',
            value: dossier.specification.recovery_costs,
        },
        {
            label: 'Totaal vordering',
            value: dossier.specification.total_subject,
        },
        {
            label: 'Totaal ontvangsten',
            value: dossier.received.by_client + dossier.received.by_contractor,
        },
        {
            label: 'Openstaand saldo',
            value: dossier.specification.total_due,
            color: 'primary',
            isTotal: true,
        },
    ];
    return (_jsx(_Fragment, { children: items.map(item => {
            return (_jsxs(DefinitionList, { children: [_jsx(DataTerm, { children: item.label }), _jsx(DataDefinition, { color: item.color, isTotal: item.isTotal, children: readableNumberParts(item.value, 'EUR').longDecimal })] }, item.label));
        }) }));
};
export default InvonedDossierFinances;
